const resources = {
  "en": {
    "expenseGroup": {
      "title": "Expense groups",
      "description": "Track grouped budgets against live income and spending.",
      "summary": {
        "title": "Summary",
        "groupsLabel": "Groups",
        "plannedLabel": "Planned Budget",
        "expensesLabel": "Actual Expenses",
        "incomeLabel": "Actual Income",
        "netLabel": "Net Result",
        "archivedLabel": "Archived",
        "archivedNote": "Archived groups are excluded from totals.",
        "estimatedInBase": "Actual totals are estimated from compatibility base valuations."
      },
      "tabs": {
        "active": "Active",
        "archived": "Archived"
      },
      "sections": {
        "registryTitle": "Group registry",
        "registryDescription": "Review active and archived groups without changing the existing transaction logic."
      },
      "actions": {
        "add": "Add",
        "edit": "Edit",
        "history": "History",
        "archive": "Archive",
        "restore": "Restore",
        "delete": "Delete",
        "save": "Save",
        "more": "More actions"
      },
      "popconfirm": {
        "deleteTitle": "Delete this group?"
      },
      "list": {
        "emptyActive": "No groups yet",
        "emptyArchived": "No archived groups",
        "plan": "Plan: {{amount}}",
        "expenses": "Expenses: {{amount}}",
        "income": "Income: {{amount}}",
        "net": "Net: {{amount}}",
        "estimatedIn": "Estimated in {{currency}}",
        "archived": "Archived",
        "archivedWithDate": "Archived on {{date}}"
      },
      "status": {
        "archived": "Archived"
      },
      "form": {
        "addTitle": "Add Group",
        "editTitle": "Edit Group",
        "nameLabel": "Name",
        "nameRequired": "Please enter Name",
        "nameEmpty": "Name cannot be empty or spaces",
        "plannedAmountLabel": "Planned Amount",
        "descriptionLabel": "Description"
      },
      "transactions": {
        "title": "Transactions: {{name}}",
        "loading": "Loading...",
        "empty": "No transactions found.",
        "description": "{{date}} • {{note}}",
        "estimatedIn": "Estimated in {{currency}}",
        "pending": "Revaluation pending",
        "stale": "Stale rate",
        "noNote": "No note",
        "types": {
          "expense": "Expense",
          "income": "Income",
          "other": "Other"
        }
      },
      "messages": {
        "loadGroupsError": "❌ Failed to load groups",
        "loadTransactionsError": "❌ Failed to load transactions",
        "groupUpdated": "✅ Group updated",
        "groupCreated": "✅ Group created",
        "groupDeleted": "✅ Group deleted",
        "groupArchived": "✅ Group archived",
        "groupRestored": "✅ Group restored",
        "errorWithReason": "❌ {{error}}"
      }
    }
  },
  "uk": {
    "expenseGroup": {
      "title": "Групи витрат",
      "description": "Відстежуйте згруповані бюджети поруч із фактичними доходами та витратами.",
      "summary": {
        "title": "Підсумок",
        "groupsLabel": "Групи",
        "plannedLabel": "Плановий бюджет",
        "expensesLabel": "Фактичні витрати",
        "incomeLabel": "Фактичний дохід",
        "netLabel": "Чистий результат",
        "archivedLabel": "Архівні",
        "archivedNote": "Архівні групи не входять у підсумки.",
        "estimatedInBase": "Фактичні підсумки оцінені з compatibility base valuation."
      },
      "tabs": {
        "active": "Активні",
        "archived": "Архівні"
      },
      "sections": {
        "registryTitle": "Реєстр груп",
        "registryDescription": "Переглядайте активні й архівні групи без зміни наявної логіки транзакцій."
      },
      "actions": {
        "add": "Додати",
        "edit": "Редагувати",
        "history": "Історія",
        "archive": "Архівувати",
        "restore": "Відновити",
        "delete": "Видалити",
        "save": "Зберегти",
        "more": "Додаткові дії"
      },
      "popconfirm": {
        "deleteTitle": "Видалити цю групу?"
      },
      "list": {
        "emptyActive": "Груп ще немає",
        "emptyArchived": "Немає архівних груп",
        "plan": "План: {{amount}}",
        "expenses": "Витрати: {{amount}}",
        "income": "Дохід: {{amount}}",
        "net": "Чистий результат: {{amount}}",
        "estimatedIn": "Оцінено в {{currency}}",
        "archived": "Заархівовано",
        "archivedWithDate": "Архівовано {{date}}"
      },
      "status": {
        "archived": "Архівовано"
      },
      "form": {
        "addTitle": "Додати групу",
        "editTitle": "Редагувати групу",
        "nameLabel": "Назва",
        "nameRequired": "Введіть назву",
        "nameEmpty": "Назва не може бути порожньою чи складатися лише з пробілів",
        "plannedAmountLabel": "Планова сума",
        "descriptionLabel": "Опис"
      },
      "transactions": {
        "title": "Транзакції: {{name}}",
        "loading": "Завантаження...",
        "empty": "Транзакцій не знайдено.",
        "description": "{{date}} • {{note}}",
        "estimatedIn": "Оцінено в {{currency}}",
        "pending": "Переоцінка очікується",
        "stale": "Застарілий курс",
        "noNote": "Без нотатки",
        "types": {
          "expense": "Витрата",
          "income": "Дохід",
          "other": "Інше"
        }
      },
      "messages": {
        "loadGroupsError": "❌ Не вдалося завантажити групи",
        "loadTransactionsError": "❌ Не вдалося завантажити транзакції",
        "groupUpdated": "✅ Групу оновлено",
        "groupCreated": "✅ Групу створено",
        "groupDeleted": "✅ Групу видалено",
        "groupArchived": "✅ Групу заархівовано",
        "groupRestored": "✅ Групу відновлено",
        "errorWithReason": "❌ {{error}}"
      }
    }
  }
};

export default resources;
